import React from "react"
import { Message, MessageGroup, SlickAIGroup } from "../reducers/messagesSlice"
import { PlaceholderType } from "./ChatHistory"
import DayMarker from "./DayMarker"
import { getCurrentMessageDate } from "@/lib/messageDate"
import { isObject } from "lodash"

type TopDayMarkerProps = {
  isScrolling: boolean
  topVisibleMessage: Message | MessageGroup | SlickAIGroup | PlaceholderType
}

const TopDayMarker: React.FC<TopDayMarkerProps> = ({
  isScrolling,
  topVisibleMessage,
}) => {
  if (!topVisibleMessage || !isObject(topVisibleMessage)) return null
  return (
    <div
      style={{
        pointerEvents: "none",
        position: "sticky",
        opacity: isScrolling ? 1 : 0,
        transition: "opacity 0.5s ease",
        bottom: "calc(100% - 60px)",
        marginTop: "-60px",
        marginLeft: "-14px",
        zIndex: 15,
      }}
    >
      <DayMarker date={getCurrentMessageDate(topVisibleMessage)} />
    </div>
  )
}

export default TopDayMarker
